import { Box, Flex, Group } from '@mantine/core';
import AppIcon from '@/components/AppIcon.tsx';
import {
  HiInformationCircle,
  HiMiniExclamationCircle,
  HiMiniExclamationTriangle,
} from 'react-icons/hi2';
import DatasetPill from '@/pages/Run/components/DatasetPill.tsx';
import { LogSeverity, StepExecutionLogEntry } from '@/types/stepExecutions.ts';
import LogDetailInfo from '@/pages/Run/components/StepExecutionLogs/LogDetailInfo.tsx';
import StepExecutionLogMessage from '@/pages/Run/components/StepExecutionLogs/StepExecutionLogMessage.tsx';

type StepExecutionLogProps = {
  log: StepExecutionLogEntry;
};

const StepExecutionLog = ({ log }: StepExecutionLogProps) => {
  return (
    <Group
      gap={'xs'}
      wrap={'nowrap'}
      align={'flex-start'}
      style={{ maxWidth: '100%', minWidth: 0, overflow: 'hidden' }}
    >
      <Flex
        mt={'1px'}
        role="img"
        aria-label={
          log.severity === LogSeverity.Error
            ? 'Error'
            : log.severity === LogSeverity.Warning
              ? 'Warning'
              : 'Information'
        }
        c={
          log.severity === LogSeverity.Error
            ? 'red'
            : log.severity === LogSeverity.Warning
              ? 'orange.9'
              : 'dimmed'
        }
        style={{
          position: 'relative',
          zIndex: 1,
          backgroundColor: 'white',
          borderRadius: '50%',
        }}
      >
        {(log.severity === LogSeverity.Debug || log.severity === LogSeverity.Info) && (
          <AppIcon Icon={HiInformationCircle} size={'1.3em'} />
        )}
        {log.severity === LogSeverity.Warning && (
          <AppIcon Icon={HiMiniExclamationTriangle} size={'1.3em'} />
        )}
        {log.severity === LogSeverity.Error && (
          <AppIcon Icon={HiMiniExclamationCircle} size={'1.3em'} />
        )}
      </Flex>
      <Group gap={'4px'} style={{ flexWrap: 'wrap', maxWidth: '100%', minWidth: 0, width: '100%' }}>
        <Box style={{ minWidth: 0, maxWidth: '100%', flex: '0 1 auto' }}>
          {/*{logsType === 'child' && log.parent_prefix && log.parent_prefix + ' '}*/}
          {/*{logsType === 'extract_errors' &&*/}
          {/*  log.extract_entity_prefix &&*/}
          {/*  log.extract_entity_prefix + ' '}*/}
          <StepExecutionLogMessage message={log.message} />
        </Box>
        {log.detail_message && <LogDetailInfo detailMessage={log.detail_message} />}
        {log.dataset && (
          <DatasetPill
            datasetId={log.dataset.id}
            datasetName={log.dataset.name}
            dataset={log.dataset}
          />
        )}
      </Group>
    </Group>
  );
};

export default StepExecutionLog;
